import { Box, DialogActions, DialogContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { payrollSetFilter } from "actions/payrollAction";
import { RoleSelect, StationSelect, StatusSelect } from "componentsNew/elements/SelectField";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { useCustomDrawerStyles } from "../styles";
import { CustomButton } from "componentsNew/buttons/CustomButton";
import { closeDrawer } from "actions/drawerActions";

export const PayrollDrawerContent: FC = () => {
  const classes = useCustomDrawerStyles();
  const localClasses = useStyles();
  const dispatch = useDispatch();
  const { payrollFilters } = useTypeSelectors((state) => state.payrollTable);

  const [station, setStation] = useState(payrollFilters.station);
  const [userStatus, setuserStatus] = useState(payrollFilters.userStatus);
  const [userRole, setUserRole] = useState(payrollFilters.userRole);
  const closenModal = () => dispatch(closeDrawer());
  const handleFilterSubmit = () => {
    dispatch(payrollSetFilter({ station, userStatus, userRole }));
    closenModal()
  };

  return (
    <>
      <DialogContent className={classes.drawerContent}>
        <Box className={localClasses.formBox}>
          <StationSelect
            fullWidth
            value={station}
            onChange={(value: string) => setStation(Number(value))}
          />
          <StatusSelect
            fullWidth
            value={userStatus}
            onChange={(value: string) => setuserStatus(Number(value))}
          />
          <RoleSelect
            fullWidth
            value={userRole}
            onChange={(value: string) => setUserRole(Number(value))}
          />
        </Box>
      </DialogContent>
      <DialogActions className={classes.actionSection}>
        <Box className={classes.actionButtons}>
          <Box className={classes.actionButtons}>
            <Box className={classes.actionButtonsLeft}>
              <CustomButton buttonText={"Apply"} onClick={handleFilterSubmit} variant="contained" />
              <CustomButton buttonText={"Cancel"} onClick={closenModal} variant="text" />
            </Box>
          </Box>
        </Box>
      </DialogActions>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  formBox: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(0, 3, 3),
  },
}));
